module.exports = __webpack_public_path__ + "img/3-8.c4c59039.png";